import { render, staticRenderFns } from "./ModalCampaign.vue?vue&type=template&id=3c48e283&"
import script from "./ModalCampaign.vue?vue&type=script&lang=js&"
export * from "./ModalCampaign.vue?vue&type=script&lang=js&"
import style0 from "./ModalCampaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports